// extracted by mini-css-extract-plugin
module.exports = {"body":"PageSwitch_body__17P6o"};